import React from 'react';
import PropTypes from 'prop-types';

import { useLoadingSpan } from '~/observability/useLoadingSpan';

import LoadingIndicator from '../../LoadingIndicator';

const LoadingSwitch = ({
  isLoading,
  isError,
  loadingSpanName,
  __loadingSource,
  children,
  LoadingComponent,
  ErrorComponent,
}) => {
  useLoadingSpan({ isLoading, isError, loadingSpanName, __loadingSource });
  return isLoading || isError ? (
    <LoadingIndicator isError={isError} LoadingComponent={LoadingComponent} ErrorComponent={ErrorComponent} />
  ) : (
    children
  );
};

LoadingSwitch.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isError: PropTypes.bool,
  // Optional override for the auto-derived Sentry span name (defaults to file:line via babel-loading-source).
  loadingSpanName: PropTypes.string,
  // Auto-injected by babel-loading-source. Not for callers to pass.
  __loadingSource: PropTypes.shape({ fileName: PropTypes.string, lineNumber: PropTypes.number }),
  children: PropTypes.node,
  LoadingComponent: PropTypes.elementType,
  ErrorComponent: PropTypes.elementType,
};

export default LoadingSwitch;
